import log from 'uix/logging'
import {treeAspect, isDomainRecord} from 'uix/views/utils'

export const xuser = {
  ...treeAspect,
  tabs: {
    id: {
      acl: 'g:authenticated',
      parts: [{type: 'WebAuthN'}],
    },
    start: {
      default: true,
      tabGroup: 'user',
      //~ acl: 'g:manageUsers',
      acl: 'g:debug',
      enabled: isDomainRecord,
      parts: ['UserDashboard'],
    },
    list: {
      tabGroup: 'user',
      //~ acl: 'g:manageUsers',
      acl: 'g:debug',
      enabled: isDomainRecord,
      parts: ['UserList'],
    },
    mail: {
      tabGroup: 'user',
      //~ acl: 'g:manageUsers',
      cfg: ({iconfig}) => iconfig.email.on,
      acl: 'g:debug',
      enabled: isDomainRecord,
      parts: ['MailList'],
    },
  },
}
